module.exports = __webpack_public_path__ + "img/30.789169a6.png";